<button nbButton [nbSpinner]="loading" (click)="removeLock()" size="small" outline status="primary">
  Remove {{ terminology }}
</button>
